var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcNegativeStandard = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 29,
  height: 14,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.206 0h-8.378a2.823 2.823 0 0 0-2.824 2.812v8.353a2.816 2.816 0 0 0 2.824 2.812h8.366a2.816 2.816 0 0 0 2.824-2.812V2.8c0-1.54-1.248-2.8-2.8-2.8",
  fill: "#21AB73"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.202.023H2.824A2.816 2.816 0 0 0 0 2.835v8.353A2.816 2.816 0 0 0 2.824 14h8.367a2.816 2.816 0 0 0 2.823-2.812V2.823c0-1.54-1.248-2.8-2.8-2.8",
  fill: "#1A2E80"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.944 7.91c-.304 0-.596.186-.747.384-.467.549-1.109.969-1.926.969-1.295 0-2.287-1.05-2.287-2.252 0-1.202.98-2.252 2.287-2.252.829 0 1.459.432 1.926.969.151.198.455.385.747.385.548 0 .921-.409.921-.864a.92.92 0 0 0-.151-.536C9.967 3.616 8.777 2.928 7.27 2.928c-2.322 0-4.13 1.785-4.13 4.083s1.808 4.083 4.13 4.083c1.494 0 2.696-.7 3.443-1.785a.92.92 0 0 0 .152-.536c0-.455-.374-.864-.922-.864Z",
  fill: "#fff"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.05 11.095a.911.911 0 0 1-1.82 0 .911.911 0 0 1 1.82 0Z",
  fill: "#2E80FF"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.004 2.928a.911.911 0 0 0-.91.91v6.323a.911.911 0 0 0 1.82 0V3.838a.911.911 0 0 0-.91-.91Z",
  fill: "#fff"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M25.075 6.988a.911.911 0 0 0-.91-.91H17.84a.911.911 0 0 0-.91.91c0 .502.408.91.91.91h6.324c.502 0 .91-.408.91-.91Z",
  fill: "#fff"
})));
export default SvgIcNegativeStandard;